import React from 'react';
import { AssistantChatPanel, AssistantSuggestion } from '../../../../components/AssistantPanel/AssistantChatPanel';
import {
  BanIcon,
  CoinIcon,
  FlameIcon,
  TrendingUpIcon,
  UsersIcon,
} from '../../../../components/AssistantPanel/assistant-panel-icons';
import { assistantService } from '../../../../services/assistant/assistant.service';

const SUGGESTIONS: AssistantSuggestion[] = [
  { text: 'איזה עובדים נתנו בראש השבוע?', Icon: UsersIcon },
  { text: 'מה המנות הכי חזקות השבוע?', Icon: FlameIcon },
  { text: 'כמה נמכר היום לעומת אתמול?', Icon: TrendingUpIcon },
  { text: 'כמה ביטולים היו הערב ומי ביצע אותם?', Icon: BanIcon },
  { text: 'כמה טיפ גבינו הערב?', Icon: CoinIcon },
];

export const AssistantPanel: React.FC<{ tenantId: string; opened: boolean; onClose: () => void }> = ({ tenantId, opened, onClose }) => (
  <AssistantChatPanel
    testIdPrefix="assistant"
    title="עוזר עסקי"
    subtitle="שאלו כל שאלה על הנתונים של המסעדה"
    statusLabel="מחובר לדאטה"
    placeholder="שאל שאלה על העסק..."
    suggestions={SUGGESTIONS}
    opened={opened}
    onClose={onClose}
    ask={(question, history, signal) => assistantService.ask(tenantId, question, history, signal)}
    sendFeedback={(message) => assistantService.sendFeedback(tenantId, message)}
  />
);
